// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--1BBhX","seo-block":"a10a3f92e9--seo-block--2mH4F","title":"a10a3f92e9--title--2RqUo","link":"a10a3f92e9--link--wJM8h"};